/* eslint-disable */

import React, { useState, useEffect } from "react";
import { db } from "../../firebase-config";
import { Link, useNavigate } from "react-router-dom";
import { ref, onValue } from "firebase/database";
import { differenceInDays } from "date-fns"; // Import date-fns function
import "./ViewAllAdmin.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ViewAll = () => {
  const [posts, setPosts] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const postsRef = ref(db, `superadmin/admins`);
    onValue(postsRef, (snapshot) => {
      const data = snapshot.val();
      setPosts(data || {});
    });
  }, []);

  // Calculate days remaining until a date
  const calculateDaysRemaining = (expiryDate) => {
    const currentDate = new Date();
    const parts = expiryDate.split("-");
    const parsedExpiryDate = new Date(parts[2], parts[1] - 1, parts[0]);
    return differenceInDays(parsedExpiryDate, currentDate);
  };

  // Handle search input changes
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter the posts based on the search query (case-insensitive)
  const filteredIds =
    posts && Object.keys(posts).filter((id) => {
      const fullName = posts[id]?.FullName || "";
      return fullName.toLowerCase().includes(searchQuery.toLowerCase());
    });

  return (
    <>
      <h2 className="adminlist">List of Admins</h2>
      <div className="admin-table-card">
        <div className="admin-table-header">
          <input
            type="text"
            placeholder="Search admin by name"
            value={searchQuery}
            onChange={handleSearch}
            className="admin-search-input"
          />
        </div>
        <div className="admin-table-scroll">
          <table className="admin-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Name</th>
                <th>License Expire in</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredIds && filteredIds.length > 0 ? (
                filteredIds.map((id, index) => {
                  const expiryDate = posts[id]?.["License Details"]?.ExpiryDate;
                  const daysRemaining = expiryDate
                    ? calculateDaysRemaining(expiryDate)
                    : "N/A";

                  return (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td className="admin-name" title={posts[id]?.FullName}>{posts[id]?.FullName}</td>
                      <td>{expiryDate ? `${daysRemaining} days` : "N/A"}</td>
                      <td>
                        <div className="link-buttons">
                          <Link to={"/SuperAdmin/ViewSingleAdmin" + id}>
                            <button className="btn btn-view">View</button>
                          </Link>
                          <Link to={"/SuperAdmin/EditAdmin" + id}>
                            <button className="btn btn-edit">Update</button>
                          </Link>
                          <Link to={"/SuperAdmin/LicenseDetails" + id}>
                            <button className="btn btn-view">License Details</button>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>No matching admin found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Link to={"/SuperAdmin"}>
   
      </Link>
      <ToastContainer />
    </>
  );
};

export default ViewAll;